import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/otc/smartlock/closingcodes/download";

export class DownloadSmartLockClosingCodesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: DownloadSmartLockClosingCodesReqData;

    constructor(installationNames: Array<string>) {
        super();
        this.responseType = "blob";
        this.payload = new DownloadSmartLockClosingCodesReqData(installationNames);
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.payload);
    }
}

export class DownloadSmartLockClosingCodesReqData {
    installationNames: Array<string>;

    constructor(installationNames: Array<string>) {
        this.installationNames = installationNames;
    }
}
